export const DomElements = (() => {
  const elements = {
    batteryLevel: document.querySelector('[data-battery-level]'),
    batteryFill: document.querySelector('[data-battery-level] span'),
    batteryNumber: document.querySelector('.user-details__perc-number'),
    viewMoreTileBtns: document.querySelectorAll('.tile__view-more'),
    responders: document.querySelector('.tile-responders__responders'),
    respondersAmount: document.querySelector('.tile-responders__amount'),
    popupTriggers: document.querySelectorAll('[data-popup-reveal-target]'),
    popups: document.querySelectorAll('[data-popup-target]'),
    popupClose: document.querySelectorAll('[data-popup-close]'),
    textAreas: document.querySelectorAll('textarea'),
    accordions: document.querySelectorAll('.accordion'),
    accordionTriggers: document.querySelectorAll('.accordion .accordion__head'),
    healthStatusSlides: document.querySelectorAll('.health-status__slide-section.health-status__event')
  }

  return {
    elements
  }
})();
